import Container from "@/components/atoms/Container";
import SectionHeading from "@/components/molecules/PageHeading";
import Pagination from "@/components/molecules/Pagination";
import StackedList from "@/components/organisms/StackedList";
import { PaginationProvider } from "@/contexts/PaginationContext";
import { getExercises } from "@/services/DefaultService";
import React from "react";

const Exercises: React.FC = () => {
  return (
    <Container className="mb-16">
      <PaginationProvider
        queryKey={"getExercises"}
        queryFunction={getExercises}
      >
        <SectionHeading
          title="Ejercicios de Programación"
          description="Pon a prueba tus conocimientos con estos ejercicios de programación"
        />
        <StackedList />
        <div className="mt-10">
          <Pagination />
        </div>
      </PaginationProvider>
    </Container>
  );
};

export default Exercises;
